import { iconSizes, typeScale } from '@/theme/tokens';

export const LOADING_SPINNER_PAGE_FRAME_SX = {
  minHeight: '45vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
} as const;

export const LOADING_SPINNER_PAGE_STACK_GAP = 'md' as const;

export const loadingSpinnerPageMessageSx = {
  fontSize: typeScale.md,
} as const;

export const LOADING_SPINNER_PAGE_SPINNER_SIZE = iconSizes.lg;
